import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../../assets/welcome.css";

const ResendVerification = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle, loading, success, error
  const [message, setMessage] = useState("");
  const [countdown, setCountdown] = useState(0);
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setStatus("error");
      setMessage("Email is required");
      return;
    }

    if (!validateEmail(email)) {
      setStatus("error");
      setMessage("Please enter a valid email address");
      return;
    }

    setStatus("loading");
    setMessage("Sending verification email...");

    try {
      const response = await axios.post("/api/auth/resend-verification", {
        email,
      });
      setStatus("success");
      setMessage(
        response.data.message || "Verification email sent successfully."
      );

      // Set countdown for redirect
      setCountdown(5);
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            navigate("/login");
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (error) {
      if (error.response?.status === 429) {
        // Rate limit error
        setStatus("error");
        setMessage(
          error.response.data.message ||
            "Too many attempts. Please try again later."
        );
      } else if (error.response?.status === 400) {
        setStatus("error");
        setMessage(
          error.response.data.message || "Error sending verification email."
        );
      } else {
        setStatus("error");
        setMessage("An error occurred. Please try again later.");
      }
    }
  };

  return (
    <div className="verification-container">
      <div className="verification-card">
        <h1 className="verification-title">Resend Verification Email</h1>

        {status === "success" ? (
          <div>
            <div className="verification-icon">
              <div className="verification-check">✓</div>
            </div>
            <p className="verification-message">{message}</p>
            <p className="verification-redirect">
              Redirecting to login page in {countdown} seconds...
            </p>
            <button
              onClick={() => navigate("/login")}
              className="verification-button"
            >
              Go to Login Now
            </button>
          </div>
        ) : (
          <>
            <p className="verification-message">
              {status === "idle"
                ? "Enter your email address to receive a new verification link."
                : message}
            </p>

            <form onSubmit={handleSubmit} className="resend-verification-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                className="resend-verification-input"
                disabled={status === "loading"}
              />

              <div className="verification-actions">
                <button
                  type="submit"
                  className="verification-button"
                  disabled={status === "loading"}
                >
                  {status === "loading"
                    ? "Sending..."
                    : "Send Verification Email"}
                </button>

                <button
                  type="button"
                  onClick={() => navigate("/login")}
                  className="verification-button verification-secondary"
                >
                  Back to Login
                </button>
              </div>
            </form>

            {status === "error" && (
              <p
                className="verification-message"
                style={{ color: "#ef4444", marginTop: "15px" }}
              >
                {message}
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ResendVerification;
